
import { Box, Card, Divider, Grid, Typography } from "@mui/joy";
import { ArrowLeft, UserRoundPlus, Store } from "lucide-react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { Button, Textarea, TextField } from "../../../../shared";
import { newUserValidation } from "../../../../libs/form-validations";

export default function NewUSer() {
    const navigate = useNavigate();
    const methods = useForm({
        mode: "onChange",
        defaultValues: {},
        resolver: newUserValidation
    });


    const registerUser = () => {
        console.log('hello')

    }

    const {
        handleSubmit, trigger,
        formState: { isValid },
    } = methods;




    return (
        <Box ml={3} mt={2} maxWidth={700}>
            <Box>
                <Box display={"flex"} gap={0.5} alignItems={"center"} mb={1}>
                    <Card sx={{ p: 0.5, borderRadius: "6px" }}>
                        <Store size={14} />
                    </Card>
                    <Typography level="title-lg">New User</Typography>
                </Box>
                <Typography level="body-sm">
                    Provide the supplier’s business and contact details to onboard them into the system. Once added,
                    you’ll be able to manage their product and service offerings, monitor availability, and assign them
                    to projects.
                </Typography>
            </Box>
            <Divider sx={{ mt: 2 }} />
            <Box mt={2}>
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(registerUser)}>
                        <Grid container spacing={2}>
                            <Grid xs={6}>
                                <TextField
                                    name="firstName"
                                    label="First Name"
                                    helperText="Enter the name of the user."
                                />
                            </Grid>
                            <Grid xs={6}>
                                <TextField
                                    name="lastName"
                                    label="Last Name"
                                    helperText="Enter the name of the user."
                                />
                            </Grid>


                            <Grid xs={12} >
                                <TextField
                                    name="email"
                                    label="Email"
                                    type="email"
                                    helperText="Provide a valid email for primary communication."
                                />
                            </Grid>



                        </Grid>
                        <Grid xs={12}>
                            <Typography sx={{ mt: 2 }} level="body-sm">
                                Ensure all required fields are completed accurately before proceeding.
                            </Typography>
                            <Box mt={1} display={"flex"} alignItems={"center"} gap={2}>
                                <Button variant={"soft"} startDecorator={<UserRoundPlus size={18} />} type={"submit"} disabled={!isValid}>
                                    Add User
                                </Button>
                                <Button
                                    variant={"soft"}
                                    startDecorator={<ArrowLeft size={18} />}
                                    color={"danger"}
                                    onClick={() => navigate(-1)}
                                >
                                    Back
                                </Button>
                            </Box>
                        </Grid>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
